/* Copyright 2013 - 2024 Waiterio LLC */
import ENVIRONMENT from './ENVIRONMENT.js'
import TESTING from './TESTING.js'

export default ENVIRONMENT === TESTING
